import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AccesoUsuarioComponent} from './pages/acceso-usuario/acceso-usuario.component';
import {SolicitudUsuarioComponent} from './pages/solicitud-usuario/solicitud-usuario.component';
import {ActivarUsuarioComponent} from './pages/activar-usuario/activar-usuario.component';
import {MessageComponent} from './components/message/message.component';
import { RecuperarContrasenaComponent } from './pages/recuperar-contrasena/recuperar-contrasena.component';
import { ExitoReestablecerComponent } from './components/exito-reestablecer/exito-reestablecer.component';


const routes: Routes = [
  { path: 'login', component: AccesoUsuarioComponent },
  { path: 'solicitud', component: SolicitudUsuarioComponent },
  { path: 'activar', component: ActivarUsuarioComponent },
  { path: 'recuperar', component: RecuperarContrasenaComponent },
  { path: 'mensaje', component: MessageComponent},
  { path: 'exito-reestablecer', component: ExitoReestablecerComponent},
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
